import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ReportsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/attendances/_layout/reports/')({
  validateSearch: zodValidator(ReportsSearchSchema)
});